import React, { useState, useEffect, useRef } from 'react'
import { themeConfig } from './config/themeConfig'
import TestimonialBox from './TestimonialBox'
import TestimonialOpen from './TestimonialOpen'
import './common.css'

const TestimonialWrapper = ({ themeData, isExt, theme }) => {
    const selectedTheme = themeConfig[theme]
    const testimonialType = selectedTheme?.type
    const [testimonials, setTestimonials] = useState([]);
    const sliderRef = useRef(null);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        arrows: false,
    };

    const dummyTestimonials = [
        {
            name: "Ernest Reinger",
            image: "null",
            description: "Explore everything with just a tap, connect faster and smarter with Business Bay"
        }, 
        {
            name: "Connor Roy",
            image: "null",
            description: "Businessbay is a platform that allows you to connect with people and businesses in your area."
        }, 
        {
            name: "Mark Philip",
            image: "null",
            description: "The best platform for connecting with people and businesses in your area."
        }
        
    ]

    useEffect(() => {
        if (themeData?.testimonialObj?.content) {
            // For external themes
            try {
                const parsedContent = JSON.parse(themeData.testimonialObj.content);
                if (parsedContent?.length) {
                    setTestimonials(parsedContent);
                }
            } catch (error) {
                console.error('Error parsing testimonial content:', error);
            }
        } else if(themeData?.testimonialArray?.length && !isExt){
            // For internal themes
            setTestimonials(themeData?.testimonialArray);
        } else if(!themeData && !isExt){
            // For template themes
            setTestimonials(dummyTestimonials);
        } else {
            setTestimonials([]);
        }
    }, [themeData]);

    if (!testimonials.length) return null;

    const handlePrev = () => {
        sliderRef.current?.slickPrev();
    };

    const handleNext = () => {
        sliderRef.current?.slickNext();
    };

    let data = {
        themeData,
        isExt,
        selectedTheme,
        testimonials,
        theme,
        settings,
        sliderRef,
        handlePrev,
        handleNext
    }

    return (
        <>
            {testimonialType === 'box' ? (
                <TestimonialBox {...data} />
            ) : (
                <TestimonialOpen {...data} />
            )}
        </>
    )
}

export default TestimonialWrapper